import styled from 'styled-components';
import { Button, DynamicLink } from 'packages/smart-home-support/components';

export const SignupForm = styled.form`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  margin: 0 auto;
`;

export const SubmitButton = styled(Button)`
  margin-top: 10px;
`;

export const InputHelp = styled.div`
  font-size: 12px;
  color: #a4a4a4;
  width: 100%;
  padding-left: 20px;
  padding-right: 20px;
  margin-top: 18px;
  text-align: center;
  box-sizing: border-box;
`;

export const FormHelp = styled.div`
  font-size: 16px;
  color: #1b1b1b;
  margin-top: 40px;
  text-align: center;
  line-height: 1.5;
`;

export const FinePrint = styled.div`
  font-size: 14px;
  color: #1b1b1b;
  margin-top: 18px;
  text-align: center;
  line-height: 1.5;
`;

export const FormHelpLink = styled(DynamicLink)`
  cursor: pointer;
  font-weight: bold;
  text-decoration: underline;
  color: #1b1b1b;
`;

export const HeadingPhoneNumber = styled.span`
  font-weight: bold;
  white-space: nowrap;
`;

export const Error = styled.div`
  padding-top: 10px;
  min-height: 20px;
  color: ${(props) => props.theme.colors.error};
  font-size: 14px;
  text-align: center;
`;



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/auth/styles.tsx